<template>
  <section class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <h3 class="card-title">Detail Barang Keluar
                / ID Barang Keluar = {{ $route.query['barang_keluar_id'] }}</h3>
            </div>  
        </div>
        <div class="row">
            <div class="col-12" style="padding-bottom:10px;">
				<router-link
				  :to="{
					path: '/barang_keluar',
					query: { tahun: tahunBarangKeluar }
				  }"
				>
					<i class="fa fa-arrow-left">&nbsp;Kembali</i>
				</router-link>
				
                <!--
				<router-link :to='"/barang_keluar"' >
                                <i class="fa fa-arrow-left">&nbsp;Kembali</i>
                            </router-link>
                -->
				
                    &nbsp;

                <button v-if="get_selisih >= 0" type="button" class="btn btn-sm btn-primary" @click="newModal">
                    <i class="fa fa-plus-square"></i>
                    Tambah Detail Barang Keluar
                </button>
            </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card">
                <div class="card-header">
                    Menampilkan <select v-model.number="perPage" @change="changePageRange">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <!--<option value="0">ALL</option>-->
                                    </select>
                                Data
                    <div class="card-tools">
                        <input type="text" v-model="searchTerm"  placeholder="Cari">
                    </div>
                </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <!--th>ID</th-->
                      <th>Rekening</th>
                      <th role='button' v-on:click="sortRecords('nama_barang', 'barang')">Nama Barang</th>
					  <th role='button' v-on:click="sortRecords('nama_barang', 'barang')">Keterangan</th>
                       <th role='button' v-on:click="sortRecords('nama', 'satuan')">Satuan</th>
                      <th role='button' v-on:click="sortRecords('qty', 'detail_barang_keluar')">Qty</th>
					<!--  <th class="text-right">Harga Satuan</th>
                      <th class="text-right">Sub Total</th>-->
                      <th v-if="get_selisih >= 0">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="detailbarangkeluar in detailbarangkeluars.data" :key="detailbarangkeluar.id">

                      <!--td>{{ruang.id}}</td-->
                      <!--<td>{{detailbarangkeluar.rekening}}</td>-->                      
                      <td>{{detailbarangkeluar.rekening}}</td>
                      <td class="text-capitalize">{{detailbarangkeluar.nama_barang}}</td>
					  <td>{{detailbarangkeluar.keterangan}}</td>
                      <td>{{detailbarangkeluar.nama_satuan}}</td>
                      <td>{{detailbarangkeluar.qty}}</td>
                    <!--  <td class="text-right">{{ returnRupiah(detailbarangkeluar.harga) }}</td>
                      <td class="text-right">{{ returnRupiah(detailbarangkeluar.total) }}</td>-->
                      <td v-if="get_selisih >= 0">

                        <a href="#" @click="editModal(detailbarangkeluar)">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        |
                        <a href="#" @click="deleteData(detailbarangkeluar.id)">
                            <i class="fa fa-trash red"></i>
                        </a>

                      </td>
                    </tr>
					
					
                  </tbody>
                </table>
              </div>
             <!-- <div class="card-body border-top">
                <div class="row justify-content-end">
                  <div class="col-md-4 col-12 text-right">
                    <strong>Grand Total : {{ returnRupiah(grandTotal) }}</strong>
                  </div>
                </div>
              </div>-->
			  
              <!-- /.card-body -->
              <div class="card-footer">
                  <div class="row">                  
                        <div class="col-12">
                            <pagination :records="parseInt(detailbarangkeluars.total)" v-model="page" :per-page="perPage" :options="{texts: { count: 'Menampilkan data ke {from} sampai {to} dari total {count} data|{count} records|One record' }}" @paginate="getResults"></pagination>
                        </div>
                  </div>
                  <div class="row">
                        <div class="col-12">
                                Menampilkan <select v-model.number="perPage" @change="changePageRange">
                                   <option value="10">10</option>
                                   <option value="20">20</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                  <!--<option value="0">ALL</option>-->
                                </select>
                            Data
                        </div>
                    </div>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>


        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">Tambah Detail Barang Keluar</h5>
                    <h5 class="modal-title" v-show="editmode">Ubah Detail Barang Keluar</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- <form @submit.prevent="createUser"> -->

                <form @submit.prevent="editmode ? updateDetailBarangKeluar() : createDetailBarangKeluar()">
                    
                    <div class="modal-body">
                        <!--<div class="form-group">
                            <label>Kategori Barang</label>
                            <v-select :options="kategoris" :reduce="(kategori) => kategori.id"
                                        label="Nama" 
                                        @input="loadBarangs"
                                        v-model="form.kategori_barang_id"
                            ></v-select>
                            <has-error :form="form" field="kategori_barang_id"></has-error>
                        </div>-->
                        <div class="form-group">
                            <label>Nama Barang</label>
                            <v-select :options="barangs" :get-option-label="getLabel" :reduce="(barang) => barang.barang_id"
                                        label="nama_barang"
                                        v-model="form.barang_id"
                                        @option:selected="setSelected"
                            >
                            <!--    <template #option="{ nama_barang, satuan, keterangan, stok, barang_id, harga }">
                                    {{ nama_barang }} ({{ satuan }}) - {{ keterangan }} | Rp. {{ returnRupiah(harga) }} | Stok : {{ stok }}
                                </template> -->
								
							<template #option="{ nama_barang, satuan, keterangan, stok, barang_id, harga }">
                                    {{ nama_barang }} ({{ satuan }}) - {{ keterangan }} | Stok : {{ stok }}
                                </template>	
								
                            </v-select>
                            <p class="text-danger">Stok : {{stok}} {{satuan}}</p>
                            <has-error :form="form" field="barang_id"></has-error>
                        </div>
                        <div class="form-group">
                            <label>Qty</label>
                            <input style="text-align:right;" v-model="form.qty" type="number" id="qty" name="qty"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('Qty') }">
                            <has-error :form="form" field="qty"></has-error>
                        </div>
                    </div>

                     <input type="hidden" v-model="form.barang_keluar_id" name="barang_keluar_id">

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">Simpan</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">Simpan</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import Pagination from 'vue-pagination-2';

    var get_barang_keluar_id = "";
    var get_selisih = "";

    export default {
        components: {
            Pagination,
            Datepicker
        },
        data () {
            return {
                editmode: false,
                searchTerm:'',
                detailbarangkeluars : {},
                grandTotal: 0,
                barangs : [],
                kategoris : [],
                barangId :'',
                stok :'',
                satuan : '',
                harga : '',
                form: new Form({
                    id : '',      
                    barang_keluar_id: '',
                    barang_id: '',
                    nama_barang:'',
                    qty:'',
                    nama_satuan:'',
                }),
                sortIndex: 'id',
                sortDirection: 'desc',
                perPage:10,
                showTable:'detail_barang_keluar',
                page: 1,
				tahunBarangKeluar: null,
            }
        },
        methods: {   
			loadBarangKeluarMeta() {
				axios
				  .get('/api/barang_keluar/' + this.get_barang_keluar_id + '/meta')
				  .then(({ data }) => {
					  this.get_selisih = data.data.status_kunci;
					  this.tingkat = data.data.tingkat;
				  })
				  .catch(() => {
					  this.get_selisih = -1;
					  this.tingkat = '2';
				  });
			},
			
            sortRecords (index, tableName) {
               
                /*this.sortIndex = index;
                this.showTable = tableName;
                if(this.sortDirection == 'asc'){
                   this.sortDirection = 'desc';
                }else if(this.sortDirection == 'desc'){
                   this.sortDirection = 'asc';
                }else{
                   this.sortDirection = 'asc';
                }                
                this.$Progress.start();                
                this.page = 1;
                axios.get('/api/detail_barang_keluar?barang_keluar_id='+this.get_barang_keluar_id + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.detailbarangkeluars = data.data.detail_barang_keluar));
                this.$Progress.finish();*/
				
				this.sortIndex = index
				  this.showTable = tableName

				  this.sortDirection =
					this.sortDirection === 'asc' ? 'desc' : 'asc'

				  this.page = 1
				  this.getResults(1)
            },    
            changePageRange(){
                /*this.$Progress.start();
                  this.page = 1;

                    axios.get('/api/detail_barang_keluar?barang_keluar_id='+this.get_barang_keluar_id + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => (this.detailbarangkeluars = data.data.detail_barang_keluar));

                  this.$Progress.finish();*/
				  
				  this.page = 1
				this.getResults(1)
            },

            returnRupiah(val){
                var number_string = val.toString(),
                    split	= number_string.split('.'),
                    sisa 	= split[0].length % 3,
                    rupiah 	= split[0].substr(0, sisa),
                    ribuan 	= split[0].substr(sisa).match(/\d{1,3}/gi);
                    
                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }
                
                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                if(parseFloat(rupiah) == 0){
                    val = 0;
                }else{
                    val = rupiah;
                }
                
                return val;
            },
            getLabel: function(val){
                if(typeof val === 'object'){
                    return val.nama_barang+" | Stok "+val.stok+" "+val.satuan+" | "+val.keterangan;
                }
            },         
            setSelected: function(val) {
                this.stok=val.stok;
                this.satuan=val.satuan;         
            },
            //getHarga(){
                //alert(this.form.barang_id);
                //axios.get("/api/barang/getHarga",{ params: { barang_id: this.barangId, stok:this.stok } }).then(({ data }) => (this.harga = data.harga));
            //},
            getResults(page = 1) {

                  this.$Progress.start();
                  
                  axios.get('/api/detail_barang_keluar?barang_keluar_id='+this.get_barang_keluar_id+'&page=' + page + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable).then(({ data }) => {
                    this.detailbarangkeluars = data.data.detail_barang_keluar;
                    this.grandTotal = data.data.grand_total || 0;
                  });

                  this.$Progress.finish();
            },
            updateDetailBarangKeluar(){
                this.$Progress.start();
                this.form.put('/api/detail_barang_keluar/'+this.form.id)
                .then((response) => {
                    // success
                    $('#addNew').modal('hide');
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    this.$Progress.finish();
                        //  Fire.$emit('AfterCreate');

                    this.loadDetailBarangKeluars();
                })
                .catch(() => {
                    this.$Progress.fail();
                });

            },

            deleteData(id){
              Swal.fire({
                  title: 'Apa anda yakin?',
                  text: "Setelah terhapus data tidak bisa dikembalikan!",
                  showCancelButton: true,
                  confirmButtonColor: '#d33',
                  cancelButtonColor: '#3085d6',
                  confirmButtonText: 'Ya'
                  }).then((result) => {

                      // Send request to the server
                        if (result.value) {
                            this.form.delete('/api/detail_barang_keluar/'+id)
                            .then((response)=>{
                                
                                Toast.fire({
                                        icon: 'success',
                                        title: response.data.message
                                });

                                this.$Progress.finish();

                            })
                            .catch(()=>{
                                Toast.fire({
                                    icon: 'error',
                                    title: 'Some error occured! Please try again'
                                });
                            })

                            window.location.reload();
                        }
                  })
             },
            dataReset(){
                this.stok='';
                this.satuan='';
                this.harga='';
            },
            editModal(detail_barang_keluar){
                this.editmode = true;
                this.form.reset();
                this.dataReset();
                $('#addNew').modal('show');
                this.form.fill(detail_barang_keluar);
            },
            newModal(){
                this.editmode = false;
                this.form.reset();
                //this.dataReset();
                this.form.barang_keluar_id = this.get_barang_keluar_id;
                $('#addNew').modal('show');
            },
            loadKategoris(){
                axios.get("/api/kategori_barang/bklist").then(({ data }) => (this.kategoris = data.data));
            },
            loadBarangs(value){
                //console.log(event);
                axios.get("/api/barang/tkbstok",{ params: { bkid: this.get_barang_keluar_id, kb: value } }).then(({ data }) => (this.barangs = data.data));
            },/*
            loadBarangs(){
                //let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;
                axios.get("/api/barang/stok",{ params: { barang_keluar_id: this.get_barang_keluar_id } }).then(({ data }) => (this.barangs = data.data));
            },*/
            loadDetailBarangKeluars(){
                /*this.$Progress.start();

                let param = _.isEmpty(this.searchTerm) ? 'all' : this.searchTerm;

                axios.get("/api/detail_barang_keluar?search=" + param + '&sortIndex=' + this.sortIndex + '&sortDirection=' + this.sortDirection + '&showPage=' + this.perPage + '&showTable=' + this.showTable + '&barang_keluar_id=' + this.get_barang_keluar_id).then(({ data }) => (this.detailbarangkeluars = data.data.detail_barang_keluar));

                this.$Progress.finish();
				*/
				
				this.page = 1
				this.getResults(1)
            },
            
            createDetailBarangKeluar(){
                if(parseFloat(this.form.qty) > parseFloat(this.stok)){
                    Toast.fire({
                                    icon: 'error',
                                    title: 'Qty tidak boleh melebihi Stok !'
                                });
                }else{
                    this.form.post('/api/detail_barang_keluar')
                    .then((response)=>{
                        $('#addNew').modal('hide');

                        Toast.fire({
                                icon: 'success',
                                title: response.data.message
                        });

                        this.$Progress.finish();
                        this.loadDetailBarangKeluars();
                    })
                    .catch(()=>{
                        Toast.fire({
                            icon: 'error',
                            title: 'Some error occured! Please try again'
                        });
                    })

                    window.location.reload();
                }
            }
        },
        mounted() {
            console.log('Component mounted.')
        },
        created() {
            let urlParams = new URLSearchParams(window.location.search);
           
            this.get_barang_keluar_id =  urlParams.get('barang_keluar_id');
            this.get_selisih =  urlParams.get('status_kunci');

            this.$Progress.start();
			this.loadBarangKeluarMeta();
            this.loadDetailBarangKeluars();
            this.loadKategoris();
            this.loadBarangs();
            this.$Progress.finish();
			
			this.tahunBarangKeluar = this.$route.query.tahun
				  ? parseInt(this.$route.query.tahun)
				  : new Date().getFullYear()
        },
        watch: {
            searchTerm: function() {
                this.loadDetailBarangKeluars();
            }
        }
    }

</script>